import { render, staticRenderFns } from "./agency_check-record.vue?vue&type=template&id=68715bf4&scoped=true"
import script from "./agency_check-record.vue?vue&type=script&lang=ts"
export * from "./agency_check-record.vue?vue&type=script&lang=ts"
import style0 from "./agency_check-record.vue?vue&type=style&index=0&id=68715bf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68715bf4",
  null
  
)

export default component.exports